import { render, staticRenderFns } from "./addicted.vue?vue&type=template&id=ffd78ff4&scoped=true&"
import script from "./addicted.vue?vue&type=script&lang=js&"
export * from "./addicted.vue?vue&type=script&lang=js&"
import style0 from "./addicted.vue?vue&type=style&index=0&id=ffd78ff4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ffd78ff4",
  null
  
)

export default component.exports